
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generateWarrantyPDF = (claim: any) => {
  const doc = new jsPDF();
  
  // Header
  doc.setFontSize(20);
  doc.setTextColor(139, 69, 19); // Prince Jewelry brown color
  doc.text('PRINCE JEWELRY', 105, 20, { align: 'center' });
  
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text('Warranty Claim Report', 105, 30, { align: 'center' });
  
  // Claim Details
  doc.setFontSize(12);
  doc.text(`Claim ID: ${claim.id}`, 20, 50);
  doc.text(`Order No: ${claim.orderNo}`, 20, 60);
  doc.text(`Customer: ${claim.customer}`, 20, 70);
  doc.text(`Product: ${claim.product}`, 20, 80);
  doc.text(`Purchase Date: ${new Date(claim.purchaseDate).toLocaleDateString()}`, 20, 90);
  doc.text(`Warranty Period: ${claim.warrantyPeriod} months`, 20, 100);
  doc.text(`Status: ${claim.status.toUpperCase()}`, 20, 110);
  
  // Issue Description
  doc.text('Issue Description:', 20, 130);
  const splitText = doc.splitTextToSize(claim.issueDescription || 'No description provided', 170);
  doc.text(splitText, 20, 140);
  
  // Footer
  doc.setFontSize(10);
  doc.setTextColor(128, 128, 128);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 20, 280);
  doc.text('Prince Jewelry Management System', 105, 285, { align: 'center' });
  
  // Save the PDF
  doc.save(`Warranty_Claim_${claim.orderNo}.pdf`);
};

export const generateWarrantyReport = (claims: any[]) => {
  const doc = new jsPDF();
  
  // Header
  doc.setFontSize(20);
  doc.setTextColor(139, 69, 19);
  doc.text('PRINCE JEWELRY', 105, 20, { align: 'center' });
  
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text('Warranty Claims Summary Report', 105, 30, { align: 'center' });
  
  // Summary Statistics
  const total = claims.length;
  const pending = claims.filter(c => c.status === 'pending').length;
  const approved = claims.filter(c => c.status === 'approved').length;
  const rejected = claims.filter(c => c.status === 'rejected').length;
  
  doc.setFontSize(12);
  doc.text('Summary Statistics:', 20, 50);
  doc.text(`Total Claims: ${total}`, 20, 60);
  doc.text(`Pending: ${pending}`, 20, 70);
  doc.text(`Approved: ${approved}`, 20, 80);
  doc.text(`Rejected: ${rejected}`, 20, 90);
  
  // Claims Table
  const tableData = claims.map(claim => [
    claim.orderNo,
    claim.customer,
    claim.product,
    claim.status,
    new Date(claim.purchaseDate).toLocaleDateString()
  ]);
  
  (doc as any).autoTable({
    head: [['Order No', 'Customer', 'Product', 'Status', 'Purchase Date']],
    body: tableData,
    startY: 110,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [139, 69, 19] }
  });
  
  // Footer
  doc.setFontSize(10);
  doc.setTextColor(128, 128, 128);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 20, 280);
  doc.text('Prince Jewelry Management System', 105, 285, { align: 'center' });
  
  doc.save('Warranty_Claims_Summary.pdf');
};
